"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var b=require("../utils/element.js"),a=function(c){if(b.isHidden(c))return 1/0;for(var d=0,a=c.parentNode;a;)d+=1,a=a.parentNode;return d};exports.calculateDepthForNode=a
//# sourceMappingURL=calculateDepthForNode.js.map
